import "./demo.css";
import { Formulario } from "./Formulario";
import { HeroSection } from "./HeroSection";

export const Content = () => {
  return (
    <>
      <div className="top-section-background">
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
          className="background-dots"
          alt="background"
        />
        <HeroSection />
      </div>
      <Formulario />
    </>
  );
};
